<template>
  <div class="checkout-coupon">
    <div class="checkout-coupon-info">
      <span class="showcoupon-tag">
        <i class="fa fa-tag" aria-hidden="true"></i>Have a coupon?
      </span>
      <a href="javascript:void(0)" @click.prevent="openCouponForm">Click here to enter your code</a>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div id="checkout_coupon" style="display: none;">
          <p>If you have a coupon code, please apply it below.</p>

          <div>
            <span class="coupon">
              <input v-model="coupon" type="text" placeholder="Coupon code" />
            </span>
            <div class="button">
              <a href="javascript:void(0)" @click.prevent="submit">Apply Coupon</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    coupon: ''
  }),
  props: ['submit', 'openCouponForm'],
  watch: {
    coupon: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  }
}
</script>
